import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, PageEvent } from '@angular/material';
import { TimeService } from '../time.service';
import { HttpService } from '../http.service';
import { PaymentVoucherCreateComponent } from './payment-voucher-create/payment-voucher-create.component';
import { PaymentVoucherViewComponent } from './payment-voucher-view/payment-voucher-view.component';
import { ValidationService } from '../validation.service';
import { SnackbarService } from '../snackbar.service';
import { TranslateService } from '@ngx-translate/core';

export interface PaymentVoucher {
  voucher_no: string;
  date_of_payment: string;
  creation_date: string;
  type: string;
  payee: string;
  amount: number;
}

@Component({
  selector: 'app-payment-voucher',
  templateUrl: './payment-voucher.component.html',
  styleUrls: ['./payment-voucher.component.scss']
})
export class PaymentVoucherComponent implements OnInit {
  @ViewChild ('uploadDialog', {static: true}) uploadDialog: TemplateRef<any>;

  helpData = [
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];

  displayColumns = ['voucher_no', 'date_of_payment', 'creation_date', 'type', 'payee', 'amount', 'action'];

  paymentVouchersList: MatTableDataSource<PaymentVoucher>;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  showLoader = false;
  paymentVouchers = [];
  totalVouchers = 0;
  paymentVouchersFilters: any = {};
  fileLength = 0;
  uploadDocsRef: any;
  paymentId = '';
  documents = new FormData();

  constructor(public timeService: TimeService, private translation:TranslateService,private dialog: MatDialog, private http: HttpService,
              private valid: ValidationService, private snackBar: SnackbarService,) { }

  ngOnInit() {
    this.getPaymentVouchers();
  }

  getPaymentVouchers(filters: any = {}) {
    this.showLoader = true;

    filters.limit = this.paginator.pageSize || 25;
    filters.skip = this.paginator.pageIndex * (this.paginator.pageSize || filters.limit);

    this.http.get('payment_voucher/many', filters).subscribe(
      (data: any) => {
        const vouchers = data.data.paymentVouchers || [];
        this.totalVouchers = data.data.count || 0;
        this.paymentVouchers = [];
        // this.getOneVoucher(data.data.paymentVouchers[0])
        vouchers.forEach(element => {
          const temp: any = {};

          temp._id = element._id || '';
          temp.voucher_no = element.no || 'N/A';
          temp.date_of_payment = (element.payment_date) ? this.timeService.toShortDate(element.payment_date) : 'N/A';
          temp.creation_date = (element.created_date) ? this.timeService.toShortDate(element.created_date) : 'N/A';
          temp.type = (element.type == 'CASH') ? 'Cash' : (element.type == 'BANK') ? 'Bank' : 'N/A';
          temp.payee = element.payee || 'N/A';
          temp.amount = element.amount || 'N/A';

          this.paymentVouchers.push(temp);
        });
        this.showLoader = false;
        if (!this.paymentVouchersList) {
          this.paymentVouchersList = new MatTableDataSource(this.paymentVouchers);
          this.paymentVouchersList.sort = this.sort;
          this.paymentVouchersList.paginator = this.paginator;
        this.paginator._intl.itemsPerPageLabel= this.translation.instant('PAYMENT_VOUCHER.pagination_label');
        } else {
          this.paymentVouchersList = new MatTableDataSource(this.paymentVouchers);
        this.paginator._intl.itemsPerPageLabel= this.translation.instant('PAYMENT_VOUCHER.pagination_label');
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
        this.paginator._intl.itemsPerPageLabel= this.translation.instant('PAYMENT_VOUCHER.pagination_label');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  getOneVoucher(voucher) {
    this.showLoader = true;
    const query = {
      id: voucher._id
    };
    this.http.get('payment_voucher', query).subscribe(
      (data: any) => {
        this.showLoader = false;
        if (data.statusCode === 200) {
          const dialogRef = this.dialog.open(PaymentVoucherViewComponent, {
            data: data.data
          });

          dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
          });
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  createPaymentVoucher() {
    const dialogRef = this.dialog.open(PaymentVoucherCreateComponent, {

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.statusCode == 200) {
        this.getPaymentVouchers();
      }
    });
  }

  pageNavigate(event: PageEvent) {
    this.paymentVouchersFilters.limit = event.pageSize;
    this.paymentVouchersFilters.skip = event.pageIndex * event.pageSize;
    this.getPaymentVouchers(this.paymentVouchersFilters);
  }
  fileChanged(event: any) {
    if (event.target.files.length) {
      this.fileLength = event.target.files.length;
      for (let x = 0; x < this.fileLength; x++) {
        this.documents.append('docs', event.target.files[x]);
      }
    } else {
      this.documents.delete('docs');
    }
  }
  openUploadDialog(element) {
    this.documents = new FormData();
    this.paymentId = element._id;
    this.uploadDocsRef = this.dialog.open(this.uploadDialog);
  }
  uploadDocs(element) {

    if (this.fileLength > 0) {
      this.http.upload('v2/payment_voucher/' + this.paymentId, this.documents).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            this.snackBar.openSnackBar(this.translation.instant('PAYMENT_VOUCHER.docsUpload'), '');
            this.paymentId = '';
            this.fileLength = 0;
            this.uploadDocsRef.close();
            this.getPaymentVouchers();
            this.documents = new FormData();
          }
        },
        (err: any) =>{
          this.snackBar.openSnackBar(err.error.message, '', 'err');
          this.documents = new FormData();
        }
      );
    } else {
      this.snackBar.openSnackBar(this.translation.instant('PAYMENT_VOUCHER.choose'), '', 'err');
    }
  }

}
